export default {
  个人信息: "Personal Information",
  用户姓名: "User Name",
  工号: "Employee ID",
  部门: "Department",
  岗位: "Position",
  邮箱: "Email",
  帐号密码信息: "Account Password Information",
  修改帐号密码: "Change Password",
  获取验证码: "Get Verification Code",
  下一步: "Next Step",
  邮箱号: "Email Address",
  请输入邮箱: "Please enter your email!",
  请输入有效的邮箱格式: "Please enter a valid email format",
  验证码: "Verification Code",
  请输入验证码: "Please enter the verification code!",
  s后重试: "s before retry",
  密码修改成功: "Password changed successfully, please login with new password",
  邮箱验证失败: "Email verification failed",
};
